<template><div><h1 id="sprachen" tabindex="-1"><a class="header-anchor" href="#sprachen"><span>Sprachen</span></a></h1>
<p>Sprachen — Definiert die Sprachen</p>
<h2 id="beschreibung" tabindex="-1"><a class="header-anchor" href="#beschreibung"><span>Beschreibung</span></a></h2>
<p>Definiert die Korrespondenzsprachen, in welcher eine Adresse angeschrieben werden möchte. Nur Einträge aus dieser Tabelle können in der Adressverwaltung erfasst werden.</p>
<p>Pfad: <code v-pre>Personen → Tabellen → Sprachen</code></p>
<h2 id="datenfelder" tabindex="-1"><a class="header-anchor" href="#datenfelder"><span>Datenfelder</span></a></h2>
<dl>
<dt>S</dt>
<dd>Kürzel für den Sprachcode, wie er im System angezeigt wird</dd>
<dt>Sprachcodebezeichnung</dt>
<dd>Sprachcodebezeichnung</dd>
</dl>
<h2 id="funktionen" tabindex="-1"><a class="header-anchor" href="#funktionen"><span>Funktionen</span></a></h2>
<p>Standardfunktionalität</p>
<h2 id="siehe-auch" tabindex="-1"><a class="header-anchor" href="#siehe-auch"><span>Siehe auch</span></a></h2>
</div></template>


